import React from "react";
import "./_EmployeeDetails.scss";
import Button from "../../Button/index";
import SubTitle from "../../../components/SubTitle/SubTitle";
import { PersonalInfoDetails, ProInfoDetails } from "./EmployeeDetails";
import { openModal, closeModal } from "../../../slices/modals";
import { useDispatch, useSelector } from "react-redux";
import Upload from "../../../components/UploadImg/index";
import getAccess from "../../../utilities/getAccess";
import { deactivationOrDeletionUserAccount } from "../../../slices/user";
import EmployeeItem from "./EmployeeItem";
import { getFormattedDate } from "../../../utilities/getFormattedDate";
import { Table, Empty } from "antd";

const EmployeeDetails = (props) => {
  const { handleClose, id, oneUser, id_user, setNotice } = props;
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user?.fetchMe);
  const { AllLeaves } = useSelector((state) => state?.leave || {});
  
  // Calculate maternity leave balance (yearly-based)
  const maternityLeaveBalance = React.useMemo(() => {
    if (!AllLeaves || !Array.isArray(AllLeaves)) return null;
    
    // Get current year boundaries
    const now = new Date();
    const currentYear = now.getFullYear();
    const yearStart = new Date(currentYear, 0, 1); // January 1st
    const yearEnd = new Date(currentYear, 11, 31, 23, 59, 59, 999); // December 31st
    
    const activeMaternityLeaves = AllLeaves.filter((leave) => {
      const typeName = (leave?.type?.name || '').toLowerCase();
      const statusCode = (leave?.status?.code || '').toLowerCase();
      const userId = leave?.user?._id || leave?.user;
      const leaveStartDate = new Date(leave.dateStart);
      
      // Filter by: not rejected AND same user AND start date is within current calendar year
      return (
        typeName === 'maternity' && 
        statusCode !== 'rejected' &&
        (userId === oneUser?._id || userId?.toString() === oneUser?._id?.toString()) &&
        leaveStartDate >= yearStart &&
        leaveStartDate <= yearEnd
      );
    });
    const remaining = Math.max(0, 2 - activeMaternityLeaves.length);
    return `${remaining} of 2 leaves (${currentYear})`;
  }, [AllLeaves, oneUser?._id]);
  const handleUserDeactivationOrDeletion = (action) => {
    dispatch(closeModal("confirm-delete-modal"));

    dispatch(deactivationOrDeletionUserAccount({ id:id_user,action })).then((res) => {
      if (res?.error) {
        setNotice({
          text: res?.error?.message,
          open: true,
          state: "error",
        });
      } else {
        if (res?.payload?.message) {
          setNotice({
            text: res?.payload?.message,
            open: true,
            state: "success",
          });

          setTimeout(() => {
            setNotice({
              open: false,
            });
            handleClose(id);
          }, 1500);
        }
      }
    });
  };
  const btnTextSuspendedAccount = oneUser?.status === 'Dismissed' ? "rehire" : "dismiss"
  return (
    <>
      <div className="EmployeeDetails__header">
        <div className="employeeDetails__identity">
          <Upload
            img={oneUser?.img}
            width={"70px"}
            height={"70px"}
            uploadPhoto={true}
          />
          <div className="employeeDetails__identity_name">
            <span>{oneUser?.fullName}</span>
            <p>{oneUser?.jobTitle}</p>
          </div>
        </div>
        <div className="button_wraper">
          {
           getAccess(
            user?.permissions,
            user?.permissionGroups?.[0]?.permissions,
            "USER",
            "EDIT"
          ) && (
            <>
              <Button
                text={btnTextSuspendedAccount.charAt(0).toUpperCase() + btnTextSuspendedAccount.slice(1)}
                className={"toggle-status-button"}
                type="button"
                onClick={() =>
                  dispatch(
                    openModal("confirm-delete-modal", {
                      id: id_user,
                      action: btnTextSuspendedAccount,
                      Item: "employee",
                      deleteHandler: () => handleUserDeactivationOrDeletion(btnTextSuspendedAccount),
                    })
                  )
                }
            /> 
             
              <Button
              text={"Delete"}
              className={"delete_button"}
              type="button"
              onClick={() =>
                dispatch(
                  openModal("confirm-delete-modal", {
                    id: id_user,
                    action:"delete",
                    Item: "employee",
                    deleteHandler: () => handleUserDeactivationOrDeletion('delete'),
                  })
                )
              }
            />
            </>
          )}
          {getAccess(
            user?.permissions,
            user?.permissionGroups?.[0]?.permissions,
            "USER",
            "EDIT"
          ) && (
            <Button
              text={"Edit Employee"}
              className={"edit-button"}
              onClick={() =>
                dispatch(openModal("UpdateUserModal", oneUser)) ||
                handleClose(id)
              }
            />
          )}
        </div>
      </div>
      
      {oneUser?.status === 'Dismissed' && oneUser?.statusUpdatedAt && 
        <EmployeeItem
        label="Dismissed Date"
        info={getFormattedDate(new Date(oneUser?.statusUpdatedAt), "-", true)}
        color="red"
        />
      }
      {oneUser?.statusUpdatedAt && oneUser?.status !== 'Dismissed' && 
        <EmployeeItem
        label="Last Date Account hire/rehire"
        info={getFormattedDate(new Date(oneUser?.statusUpdatedAt), "-",true)}
        color="red"
        />
      }
      
      <SubTitle
        subTitle={"Personal Info"}
        className="subtitle__employee_info"
      />
      <PersonalInfoDetails
        fullName={oneUser?.fullName}
        email={oneUser?.email}
        phone={oneUser?.phone}
        birthday={oneUser?.birthday}
        gender={oneUser?.gender}
        address={oneUser?.address}
      />
      <div style={{ marginTop: "34px" }}>
        <SubTitle
          subTitle={"Professional Info"}
          className="subtitle__employee_info"
        />
      </div>
      <ProInfoDetails
        hiringDate={oneUser?.hiringDate}
        jobTitle={oneUser?.jobTitle}
        department={oneUser?.department?.name}
        headquarter={oneUser?.headquarter?.name}
        status={oneUser?.status}
        role={oneUser?.role?.code}
        balance={oneUser?.balance?.toFixed(2)}
        authorisationBalance={oneUser?.authorisationBalance?.toFixed(2)}
        balanceLeft={oneUser?.balanceLeft ? oneUser.balanceLeft.toFixed(2) : '0.00'}
        authorisationBalanceLeft={oneUser?.authorisationBalanceLeft?.toFixed(2)}
        remoteDays={oneUser?.remoteDays}
        sickLeaveBalance={oneUser?.sickLeaveBalance != null ? oneUser.sickLeaveBalance : 10}
        maternityLeaveBalance={maternityLeaveBalance}
      />

      {Array.isArray(oneUser?.dismissalPayouts) && oneUser.dismissalPayouts.length > 0 && (
        <div style={{ marginTop: "34px" }}>
          <SubTitle
            subTitle="Dismissal Payout History"
            className="subtitle__employee_info"
          />
          <Table
            size="small"
            rowKey="_id"
            pagination={false}
            dataSource={oneUser.dismissalPayouts}
            columns={[
              {
                title: "Dismissal Date",
                dataIndex: "dismissalDate",
                key: "dismissalDate",
                render: (val) =>
                  val ? getFormattedDate(new Date(val), "-", true) : "—",
              },
              {
                title: "Balance Left (days)",
                dataIndex: "balanceLeftAtDismissalDays",
                key: "balanceLeftAtDismissalDays",
                render: (val) =>
                  val != null ? Number(val).toFixed(2) : "—",
              },
              {
                title: "Payout Amount",
                dataIndex: "payoutAmount",
                key: "payoutAmount",
                render: (val) =>
                  val != null ? Number(val).toFixed(2) : "—",
              },
            ]}
          />
        </div>
      )}
    </>
  );
};

export default EmployeeDetails;
